import { Component, forwardRef, Host, Input, OnInit, Optional, SkipSelf } from '@angular/core';
import { ControlContainer, NG_VALUE_ACCESSOR } from '@angular/forms';
import { Log } from 'src/app/core/console.log';
import { Address } from 'src/app/models/address';
import { AddressType } from 'src/app/models/type/address.type.enum';
import { MasterService } from 'src/app/services/master.service';
import { DropdownFormControl } from 'src/app/shared/inputs/dropdown-form-control';
import { inputMgsErrs } from 'src/app/validators/message-validation';

@Component({
  selector: 'app-input-dp-address-type',
  templateUrl: './input-dp-address-type.component.html',
  styleUrls: ['./input-dp-address-type.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => InputDpAddressTypeComponent),
      multi: true
    },
  ]
})
export class InputDpAddressTypeComponent extends DropdownFormControl implements OnInit {
  errors = inputMgsErrs.addressType;
  @Input() address?: Array<Address>;
  @Input() exceptAddressType?: Array<AddressType>;

  constructor(
    @Optional() @Host() @SkipSelf()
    private cc: ControlContainer,
    private masterService: MasterService
  ) { super(cc); }

  ngOnInit() {
    this.checkInitialControl();
    this.initDropdownList();
  }

  initDropdownList() {
    this.clearDropDownDefault();
    this.masterService.getAddressType().subscribe(result => {
      const list = result.filter(item => {
        return this.exceptAddressType ? !this.exceptAddressType.includes(item.value) : true;
      });
      this.items.push(...list);
      this.findValueFromList(this.value);
    }, error => {
      Log.error(error);
    });
  }

  resetDropdownList(types: Array<Address>) {
    this.clearDropDownDefault();
    if (types instanceof Array) {
      types.forEach(item => {
        switch (item.type) {
          case AddressType.registered:
            this.items.push({ label: 'address.type.registered', value: AddressType.registered });
            break;
          case AddressType.present:
            this.items.push({ label: 'address.type.present', value: AddressType.present });
            break;
          case AddressType.office:
            this.items.push({ label: 'address.type.office', value: AddressType.office });
            break;
        }
      });
    }
  }

  protected setValue(val: any) {
    super.setValue(val);
    if (this.address) {
      this.resetDropdownList(this.address);
    }
    this.findValueFromList(this.value);
  }

}
